import { render, staticRenderFns } from "./ClaimsReporting.vue?vue&type=template&id=344c765a"
import script from "./ClaimsReporting.vue?vue&type=script&lang=js"
export * from "./ClaimsReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports